import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { FormShortUrlService } from '@common/services/form_short_url_service'

/**
 * 短縮URL (/s/:code) を解決し、/login/:schoolId/:projectId へリダイレクトする
 */
function ShortUrlRedirect() {
  const { code } = useParams<{ code: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!code) {
      setError('URLが正しくありません。')
      return
    }
    let cancelled = false
    const service = new FormShortUrlService()
    service
      .getByCode(code.toLowerCase())
      .then((res) => {
        if (cancelled) return
        if (!res) {
          setError('このリンクは無効か、期限切れです。')
          return
        }
        navigate(`/login/${res.schoolAccountId}/${res.projectId}`, { replace: true })
      })
      .catch(() => {
        if (!cancelled) setError('リンクの解決に失敗しました。')
      })
    return () => {
      cancelled = true
    }
  }, [code, navigate])

  if (error) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <p style={{ color: '#c62828', marginBottom: '16px' }}>{error}</p>
      </div>
    )
  }
  return (
    <div style={{ padding: '24px', textAlign: 'center' }}>
      <p>リダイレクトしています...</p>
    </div>
  )
}

export default ShortUrlRedirect
